import React, { createContext, useEffect, useState } from "react";

import { useMetadata } from "../hooks/useMetadata";
import { ChatContextState } from "../types";

type ChatContext = ChatContextState & {
  setPendingQuestion: React.Dispatch<React.SetStateAction<string | undefined>>;
  enabledDocumentIds: string[];
  setEnabledDocumentIds: React.Dispatch<React.SetStateAction<string[]>>;
  selectedModel: string | undefined;
  setSelectedModel: React.Dispatch<React.SetStateAction<string | undefined>>;
  modelOptions: { value: string; label: string }[];
};

export const ChatContext = createContext<ChatContext | null>(null);

const ChatContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [pendingQuestion, setPendingQuestion] = useState<string | undefined>();
  const [enabledDocumentIds, setEnabledDocumentIds] = useState<string[]>([]);

  const metadata = useMetadata();
  const modelOptions = metadata.availableModels.map((model) => ({
    value: model,
    label: model,
  }));
  const [selectedModel, setSelectedModel] = useState<string | undefined>();

  useEffect(() => {
    if (modelOptions.length > 0) {
      setSelectedModel(modelOptions[0]?.value);
    }
  }, [metadata.availableModels]);

  return (
    <ChatContext.Provider
      value={{
        pendingQuestion,
        setPendingQuestion,
        enabledDocumentIds,
        setEnabledDocumentIds,
        selectedModel,
        setSelectedModel,
        modelOptions,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContextProvider;
